
const meConfig = {
  // Read an Invitation
  "/me/invitations/:invitationId.read": {
    protocol: "ws",
    resource: "/me/invitations/:invitationId",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "me",
  },
  // Accept an Invitation¶
  "/me/invitations/:invitationId/accept.update": {
    protocol: "ws",
    resource: "/me/invitations/:invitationId/accept",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "me",
  },
  // API/falcon/me =>  /me/notifications
  "/me/notifications.read": {
    protocol: "ws",
    resource: "/me/notifications",
    restful: false,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "events",
  },
  // Delete Account
  "/me.delete": {
    protocol: "ws",
    resource: "/me",
    restful: true,
    method: "delete",
    buildParams: null,
    action: null,
    mockSelector: "me",
  },
};

export default meConfig;
